module.exports = __webpack_public_path__ + "img/in-logo.7c1cede1.svg";